import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';
import { DaybookType } from './getDaybookList';

export type SubmitGetDaybookItem = {
  user: string;
  daybookId: string;
};

export type ResponseGetDaybookItem = {
  id: string;
  text?: string;
  textBin?: string;
  typeDaybook?: DaybookType;
  creationDate: string;
};

export const getDaybookItem = async (data: SubmitGetDaybookItem) => {
  const response = await axios.get(`${rootUrl}/psychologist/daybook/item`, {
    params: {
      user: data.user,
      daybookId: data.daybookId,
      token: getCookies('auth'),
    },
    headers: {
      'Cache-Control': 'no-store',
    },
  });

  return response.data;
};
